__turbopack_context__.v({
  "activities_sec": "Home-module-scss-module__ndsUTa__activities_sec",
  "activities_slider": "Home-module-scss-module__ndsUTa__activities_slider",
  "activity_bg_image": "Home-module-scss-module__ndsUTa__activity_bg_image",
  "activity_child": "Home-module-scss-module__ndsUTa__activity_child",
  "activity_overlay": "Home-module-scss-module__ndsUTa__activity_overlay",
  "all_blog_content": "Home-module-scss-module__ndsUTa__all_blog_content",
  "all_blog_image": "Home-module-scss-module__ndsUTa__all_blog_image",
  "background_image": "Home-module-scss-module__ndsUTa__background_image",
  "banner_slider_wrapper": "Home-module-scss-module__ndsUTa__banner_slider_wrapper",
  "banner_text": "Home-module-scss-module__ndsUTa__banner_text",
  "banner_text_con": "Home-module-scss-module__ndsUTa__banner_text_con",
  "banner_video": "Home-module-scss-module__ndsUTa__banner_video",
  "blogs": "Home-module-scss-module__ndsUTa__blogs",
  "blogs_sec": "Home-module-scss-module__ndsUTa__blogs_sec",
  "booking_col": "Home-module-scss-module__ndsUTa__booking_col",
  "booking_cont": "Home-module-scss-module__ndsUTa__booking_cont",
  "booking_sec": "Home-module-scss-module__ndsUTa__booking_sec",
  "button_col": "Home-module-scss-module__ndsUTa__button_col",
  "button_sec": "Home-module-scss-module__ndsUTa__button_sec",
  "check_now_btn": "Home-module-scss-module__ndsUTa__check_now_btn",
  "conference_btn": "Home-module-scss-module__ndsUTa__conference_btn",
  "explore_btn": "Home-module-scss-module__ndsUTa__explore_btn",
  "hall_sec": "Home-module-scss-module__ndsUTa__hall_sec",
  "help_sec": "Home-module-scss-module__ndsUTa__help_sec",
  "help_sec_child": "Home-module-scss-module__ndsUTa__help_sec_child",
  "home_banner": "Home-module-scss-module__ndsUTa__home_banner",
  "home_banner_image": "Home-module-scss-module__ndsUTa__home_banner_image",
  "home_page_search_form_wrapper": "Home-module-scss-module__ndsUTa__home_page_search_form_wrapper",
  "hyperlink_button": "Home-module-scss-module__ndsUTa__hyperlink_button",
  "image_overlay": "Home-module-scss-module__ndsUTa__image_overlay",
  "image_sec": "Home-module-scss-module__ndsUTa__image_sec",
  "image_sec_left": "Home-module-scss-module__ndsUTa__image_sec_left",
  "mobiel_home_banner_image": "Home-module-scss-module__ndsUTa__mobiel_home_banner_image",
  "privacy_policy": "Home-module-scss-module__ndsUTa__privacy_policy",
  "right_bottom_text": "Home-module-scss-module__ndsUTa__right_bottom_text",
  "room_center": "Home-module-scss-module__ndsUTa__room_center",
  "room_con": "Home-module-scss-module__ndsUTa__room_con",
  "room_left": "Home-module-scss-module__ndsUTa__room_left",
  "room_right": "Home-module-scss-module__ndsUTa__room_right",
  "room_right_bottom": "Home-module-scss-module__ndsUTa__room_right_bottom",
  "single_blog_parent": "Home-module-scss-module__ndsUTa__single_blog_parent",
  "single_hotel_search_form_container": "Home-module-scss-module__ndsUTa__single_hotel_search_form_container",
  "slick-next": "Home-module-scss-module__ndsUTa__slick-next",
  "slick-prev": "Home-module-scss-module__ndsUTa__slick-prev",
  "slick_slide": "Home-module-scss-module__ndsUTa__slick_slide",
  "slick_slide_image": "Home-module-scss-module__ndsUTa__slick_slide_image",
  "slick_slide_text": "Home-module-scss-module__ndsUTa__slick_slide_text",
  "testi_left": "Home-module-scss-module__ndsUTa__testi_left",
  "testi_right": "Home-module-scss-module__ndsUTa__testi_right",
  "testimonial": "Home-module-scss-module__ndsUTa__testimonial",
  "testimonial_sec": "Home-module-scss-module__ndsUTa__testimonial_sec",
  "video_bg": "Home-module-scss-module__ndsUTa__video_bg",
  "videobanner": "Home-module-scss-module__ndsUTa__videobanner",
});
